<template>
    <st-modal v-model="confirm.toggle" :title="confirm.info.title" :width="40" :closeVisible="false">
        <template v-slot:body>
            <div class="confirm-content" v-html="confirm.info.content" />
        </template>

        <template v-slot:footer>
            <st-divider :between="0" clear>
                <st-float float="right">
                    <st-button size="small" color="primary" @click="confirmHandler">
                        {{ confirm.options.buttonText.confirm }}
                    </st-button>
                    <st-button size="small" v-show="confirm.options.isCancle" @click="closeHandler">
                        {{ confirm.options.buttonText.cancle }}
                    </st-button>
                </st-float>
            </st-divider>
        </template>
    </st-modal>
</template>
<script>
import { state, mutations } from "./store";

export default {
    name: "stConfirm",
    computed: {
        confirm() {
            return state.confirm;
        }
    },
    methods: {
        confirmHandler() {
            const { onConfirm } = this.confirm.info;

            if (!onConfirm) console.warn("no after effect for onConfirm");

            onConfirm && onConfirm();

            mutations.closeConfirm();
        },

        closeHandler() {
            const { onCancle } = this.confirm;
            onCancle && onCancle();

            mutations.closeConfirm();
        }
    }
};
</script>
<style lang="scss">
.confirm-content {
    display: block;
    width: 100%;
    word-break: break-all;
}
</style>
